/**
 * Balance from API is in minor units. `currency` is usually an ISO 4217 code (defaults to INR).
 * Extended or numeric codes (e.g. four digits) are shown with a plain amount plus the code — `Intl`
 * only accepts standard 3-letter ISO currency codes for `style: 'currency'`.
 */
export function formatWalletBalanceMinor(amount, currency = 'INR') {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  const code = typeof currency === 'string' && currency.trim() !== '' ? currency.trim() : 'INR';
  const value = Number(amount) / 100;
  const fraction = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: code,
      ...fraction,
    }).format(value);
  } catch {
    return `${value.toLocaleString('en-IN', fraction)} ${code}`;
  }
}

/**
 * `GET /app/public/wallet/:id/statement` — ledger lines live on `transactions`.
 * Pagination uses `next_cursor` (opaque object); pass it back as query `cursor` (JSON string).
 */
export function extractStatementEntries(data) {
  if (!data || typeof data !== 'object' || !Array.isArray(data.transactions)) {
    return [];
  }
  return data.transactions;
}
